<template>
  <div class="bookmark-icon" @click="callAPI">
    <!-- <img
      v-if="toggle"
      src="@/assets/images/notsaved.png"
      class="material-icons"
    /> -->
    <img
      v-if="info.savedJob"
      src="@/assets/images/saved.png"
      class="material-icons"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BookmarkIcon",
  props: ["info"],

  data() {
    return {
      // toggle: true,
      jobId: ''
    };
  },
  mounted() {
    this.jobId = this.$route.params.jobid
  },
  computed: {
    ...mapState({
      // shortlistJobResponse: (state) => state.GeneralModule.shortlistJobResponse,
      // removeJobResponse: (state) => state.GeneralModule.removeJobResponse,
    }),
  },
  watch: {
    // shortlistJobResponse() {
    //   if (!this.shortlistJobResponse.isSaving) {
    //     if (this.shortlistJobResponse.responseData.status === 200) {
    //       this.emitFunction();
    //     }
    //   }
    // },
    // removeJobResponse() {
    //   if (!this.removeJobResponse.isRemoving) {
    //     if (this.removeJobResponse.responseData.status === 200) {
    //       this.emitFunction();
    //     }
    //   }
    // },
  },
  methods: {
    emitFunction() {
      this.$emit("refetch");
    },
    callAPI() {
      // // ! If Not saved
      // if (this.toggle) {
      //   const obj = {
      //     employeeid: this.info.user,
      //     jobId: this.info.profile._id,
      //   };
      //   this.$store.dispatch("GeneralModule/shortlistJob", obj);
      // }
      // // ! if saved
      // else {
      const obj = {
        employeeid: this.info._id,
        jobId: this.jobId,
      };
      this.$store.dispatch("GeneralModule/removeJob", obj);
      // }
      // this.toggle = !this.toggle;
      this.emitFunction();
    },
  },
  created() {
    // if (this.info.savedJob) {
    //   this.toggle = false;
    // }
  },
};
</script>

<style scoped>
.bookmark-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
  cursor: pointer;
  opacity: 0.7;
}
img {
  width: 40px;
  height: 40px;
}

.bookmark-icon i {
  font-size: 24px;
  color: #555;
}
</style>
